// extracted by mini-css-extract-plugin
export default {"roundIcon":"MyVehiclesData_roundIcon__ztUCK"};